import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function MethodReveal() {
  return <section className="py-24 bg-blush-50 relative overflow-hidden" data-id="element-115">
      {/* Decorative floral SVG hint */}
      <svg className="absolute top-0 right-0 text-blush-100 w-64 h-64 -translate-y-1/2 translate-x-1/3 transform opacity-50" viewBox="0 0 100 100" fill="currentColor" data-id="element-116">
        <path d="M50 0 C60 20 80 40 100 50 C80 60 60 80 50 100 C40 80 20 60 0 50 C20 40 40 20 50 0 Z" data-id="element-117" />
      </svg>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-118">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.1
          }
        }
      }} className="text-center mb-16" data-id="element-119">
          <motion.h2 variants={fadeInUp} className="text-3xl md:text-5xl font-bold text-ink-900 mb-8" data-id="element-120">
            PERO ESPERA... ¿NO NECESITAS TALENTO ESPECIAL?
          </motion.h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-12" data-id="element-121">
            {['Talento especial', 'Dinero para invertir mucho', 'Una tienda física', 'Años de experiencia'].map((item, i) => <motion.div key={i} variants={fadeInUp} className="bg-white p-4 rounded-lg shadow-sm border border-blush-100 flex flex-col items-center justify-center text-center" data-id="element-122">
                <span className="text-ink-800 font-medium mb-2" data-id="element-123">¿{item}?</span>
                <span className="text-red-500 font-bold text-xl flex items-center" data-id="element-124">
                  <XCircle className="w-5 h-5 mr-1" data-id="element-125" /> No.
                </span>
              </motion.div>)}
          </div>

          <motion.p variants={fadeInUp} className="text-xl md:text-2xl font-serif text-ink-900 mb-8" data-id="element-126">
            Lo que necesitas es un{' '}
            <strong className="text-emerald-900" data-id="element-127">sistema probado</strong> que te
            diga exactamente:
          </motion.p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto text-left" data-id="element-128">
            {[{
            title: 'QUÉ comprar',
            desc: 'y dónde encontrarlo por menos de $5'
          }, {
            title: 'CÓMO armarlo',
            desc: 'paso a paso, minuto a minuto'
          }, {
            title: 'CÓMO fotografiarlo',
            desc: 'para que se vea de boutique de lujo'
          }, {
            title: 'A QUÉ precio venderlo',
            desc: 'y cómo justificar ese precio con confianza'
          }].map((item, i) => <motion.div key={i} variants={fadeInUp} className="flex items-start space-x-3 bg-white/50 p-4 rounded-xl" data-id="element-129">
                <CheckCircle2 className="w-6 h-6 text-emerald-800 flex-shrink-0 mt-0.5" data-id="element-130" />
                <div data-id="element-131">
                  <strong className="block text-ink-900" data-id="element-132">{item.title}</strong>
                  <span className="text-ink-800/80 text-sm" data-id="element-133">({item.desc})</span>
                </div>
              </motion.div>)}
          </div>

          <motion.p variants={fadeInUp} className="mt-10 text-lg text-ink-800 italic" data-id="element-134">
            Eso es exactamente lo que el <strong data-id="element-135">Método 3-3-3</strong> te
            entrega.
          </motion.p>
        </motion.div>

        {/* The Big Reveal */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-emerald-900 rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-136">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-137"></div>

          <span className="inline-block px-4 py-1 bg-gold-500 text-ink-900 font-bold text-sm tracking-widest uppercase mb-6 rounded-full" data-id="element-138">
            Presentando
          </span>

          <h2 className="text-4xl md:text-6xl font-serif font-bold mb-4 text-cream-50" data-id="element-139">
            MÉTODO 3-3-3
          </h2>

          <h3 className="text-xl md:text-2xl font-sans font-light text-gold-400 mb-8" data-id="element-140">
            Emprendimiento Express — Especial Día de la Madre
          </h3>

          <p className="text-lg md:text-xl max-w-3xl mx-auto leading-relaxed text-cream-50/90 mb-10" data-id="element-141">
            El sistema completo para crear <strong data-id="element-142">3 regalos</strong> de alto
            valor percibido, en <strong data-id="element-143">3 horas</strong>, usando{' '}
            <strong data-id="element-144">3 tiendas</strong> accesibles — y generar más del 100% de
            ganancia en el mes de Mayo.
          </p>

          <div className="bg-white/10 border border-white/20 p-6 rounded-2xl backdrop-blur-sm inline-block" data-id="element-145">
            <p className="font-serif text-2xl md:text-3xl italic text-gold-400" data-id="element-146">
              "Transforma $15 de inversión en $45 de ganancia en menos de 20
              minutos."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}